<template>
  <modal>
    <h2 class="section-title m-4 text-center text-lg">おしらせ</h2>
    <div v-if="message" class="p-4 border-section_border bg-white">
      <h3 class="font-bold text-link_darker">{{ message.title }}</h3>          
      <p class="text-current">{{ getMoment(message.dispDate) }}</p>
      <p class="py-3 message_detail" v-html="message.detail.replace(/\n/g, '<br />')" />
    </div>
    <div class="w-40 mx-auto flex text-center mb-2" @click="onCheckbox">
      <span v-if="isRead">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="m424-312 282-282-56-56-226 226-114-114-56 56 170 170ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z"/></svg>
      </span>
      <span v-else>
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Z"/></svg>
      </span>
      <span class="ml-2">
        次から表示しない
      </span>
    </div>
    <div class="modal-button flex justify-between">
      <a class="button-primary block w-full" @click="close()">閉じる</a>
    </div>
  </modal>
</template>

<script>
import Modal from "../atoms/Modal"
import moment from "moment";

export default {
  name: 'NoticeModal',
  components: {
    Modal
  },
  props: {
    closeModal: {
      type: Function,
      default: function () {
        return {}
      }
    },
    message: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      isRead: false,
    }
  },
  methods: {
    getMoment: function (date) {
      return moment(date).format('YYYY/MM/DD')
    },
    onCheckbox: function () {
      this.isRead = !this.isRead
    },
    close: function(){
      this.closeModal(this.isRead)
    }
  }
}
</script>
